import { makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    maxWidth: "400px",
    margin: "0 auto",
    height: "100vh",
    background: tokens.colorNeutralBackground1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  card: {
    marginTop: tokens.spacingVerticalXXL,
    padding: tokens.spacingVerticalXL,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: tokens.shadow16,
    background: tokens.colorNeutralBackground2,
    marginBottom: tokens.spacingVerticalXXL,
  },
  header: {
    marginBottom: tokens.spacingVerticalL,
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: tokens.spacingVerticalXS,
    fontSize: tokens.fontSizeBase300,
  },
  label: {
    color: tokens.colorNeutralForeground2,
  },
  value: {
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
  },
  divider: {
    border: 0,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    margin: `${tokens.spacingVerticalL} 0`,
  },
  buttons: {
    marginTop: "auto",
    marginBottom: tokens.spacingVerticalXXL,
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    textAlign: "center",
    padding: tokens.spacingVerticalL,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "20px",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "16px",
  },
  statCard: {
    padding: "16px",
  },
  buttonContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "12px",
    paddingTop: "20px",
    borderTop: "1px solid #e1dfdd",
  },
  lastUpdatedText: {
    color: "#888",
    fontSize: "12px",
  },
  fuzzySearchContainer: {
    marginTop: "16px",
    marginBottom: "16px",
  },
  fuzzySearchTitle: {
    marginBottom: "8px",
    color: tokens.colorBrandForeground1,
  },
  fuzzySearchStatus: {
    marginTop: "4px",
    fontSize: "12px",
    color: tokens.colorNeutralForeground3,
  },
  statNumber: {
    fontSize: "32px",
    fontWeight: 700,
    color: tokens.colorBrandForeground1,
  },
  pulsingNumber: {
    fontSize: "32px",
    fontWeight: 700,
    color: tokens.colorBrandForeground1,
    animationName: {
      from: {
        opacity: "0.4",
      },
      "50%": {
        opacity: "1",
      },
      to: {
        opacity: "0.4",
      },
    },
    animationDuration: "1.5s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
  },
});

export default useStyles;
